module.exports = __webpack_public_path__ + "img/ester-logo.8180811b.svg";